import React from "react";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import FormikContainer from "../../components/Formik/FormikContainer";
import DButton from "../../components/DButton";
import FieldContainer from "../../components/Formik/FieldContainer";
import { Form } from "formik";

//import utils
import { useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import * as Yup from "yup";
import { Spinner } from "@chakra-ui/react";
import { toast } from "react-hot-toast";
import requestedBalanceServices from "../../services/requestedBalance";
const statusOption = [
  {
    id: 1,
    title: "اختر..",
    value: "",
  },
  {
    id: 2,
    title: "نجح",
    value: "success",
  },
  {
    id: 3,
    title: "فشل",
    value: "failed",
  },
];
const initialValues = { status: "" };

const validationSchema = Yup.object().shape({
  status: Yup.string().required("هذا الحقل مطلوب"),
});
const EditRequestedBalance = ({ title }) => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const onSubmit = (values, { setSubmitting }) => {
    requestedBalanceServices
      .updateRequestedBalanceStatus(id, values)
      .then((res) => {
        toast.success("تم تحديث الطلب");
        queryClient.refetchQueries(["getRequestedBalances"]);
        setTimeout(() => {
          navigate("/balance-requested", { replace: true });
        }, 1500);
      })
      .catch((err) => {
        if (err?.response.status === 404) {
          toast.error("هذا الطلب غير موجود");
        } else {
          toast.error("فشل تحديث الطلب");
        }
        setSubmitting(false);
      });
  };
  return (
    <div>
      <PageHeading>
        {title} {id}
      </PageHeading>
      <DCard className={"min-h-[400px]"}>
        <FormikContainer
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="w-full md:w-[200px] mx-auto">
                <FieldContainer
                  type="select"
                  name="status"
                  label="حالة الطلب"
                  options={statusOption}
                />
              </div>
              <DButton
                disabled={isSubmitting}
                type="submit"
                className="mx-auto min-w-[150px] flex items-center justify-center text-white"
              >
                {isSubmitting ? <Spinner /> : "تحديث"}
              </DButton>
            </Form>
          )}
        </FormikContainer>
      </DCard>
    </div>
  );
};

export default EditRequestedBalance;
